import { RegistryItem } from "@schemas/agreementconditions/schema";
import { AgreementConditionType } from "__generated__/graphql";

export const WaterLevelSchema: RegistryItem = {
	[AgreementConditionType.WaterLevel]: {
		fields: {
			"conditions.waterLevelLocation": {
				path: "waterLevelLocation",
				rules: {
					required: true,
				},
			},
		},
		toInput: (form) => ({
			waterLevelLocation: form.waterLevelLocation,
			waterLevelMin: form.waterLevelMin,
			waterLevelMax: form.waterLevelMax,
		}),
		toForm: (condition) => ({
			waterLevelLocation: condition.waterLevelLocation ?? undefined,
			waterLevelMin: condition.waterLevelMin ?? undefined,
			waterLevelMax: condition.waterLevelMax ?? undefined,
		}),
	},
};
